import EditPassword from './editPassword.vue';

export default EditPassword;